// extracted by mini-css-extract-plugin
export default {"card":"jja-z","carouselContainer":"kja-z","carouselContainerOverrides":"lja-z","carouselContent":"mja-z"};